import walletFinancialPositionsMessages from '../../../../messages/wallet/wallet-financial-positions.messages';
import { Column } from '../../../column';
import { AdministeredProduct } from '../../administered-macro-category';

export const mobileAdministeredColumns: Column<AdministeredProduct>[] = [
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderProduct,
    key: 'productName',
    type: 'string',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderCounterValueShort,
    key: 'equivalent',
    type: 'amount',
  },
];
